// iter86.88 — Tournament lifecycle pill mapping. Mirrors the backend's
// canonical ladder (backend/lifecycle.py): setup -> ready -> live ->
// final -> completed. Pre-live states read "Open" for players.
export const LIFECYCLE_PILLS = {
    setup: { label: "Open", classes: "bg-ink border-[#555] text-zinc-200" },
    ready: { label: "Open", classes: "bg-ink border-[#555] text-zinc-200" },
    live: { label: "Live", classes: "bg-blaze/15 border-blaze text-blaze", live: true },
    final: { label: "Final", classes: "bg-neon/15 border-neon text-neon", done: true },
    completed: { label: "Complete", classes: "bg-neon/20 border-neon text-neon", done: true },
};

export function lifecyclePill(state) {
    return LIFECYCLE_PILLS[state] || null;
}
